import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { CashAdvanceService } from '../../../../core/api/cash-advance.service';
import { ReimburseLogService } from '../../../../core/api/reimburse-log.service';
import { TagService } from '../../../../core/api/tag.service';
import { FileService } from '../../../../core/api/file.service';
import { HelpersService } from '../../../../core/services/helpers.service';
import { AuthService } from '../../../../core/services/auth.service';
import { LoadingService } from '../../../../core/services/loading.service';
import { ConfirmApprovalComponent } from '../confirm-approval/confirm-approval.component';
import { DetailApprovalDialogComponent } from './detail-approval-dialog/detail-approval-dialog.component';
import { CashAdvanceLogService } from '../../../../core/api/cash-advance-log.service';
import { CashAdvanceApprovalService } from '../../../../core/api/cash-advance-approval.service';
import { ActionSettlementComponent } from '../action-settlement/action-settlement.component';
import { ProfileDialogComponent } from '../../../../components/profile-dialog/profile-dialog.component';
import { FilePreviewComponent } from '../../../../components/file-preview/file-preview.component';
import moment from 'moment/moment';

@Component({
  selector: 'app-action-cash-advance-approval',
  standalone: true,
  imports: [CommonModule, MatTableModule],
  templateUrl: './action-cash-advance-approval.component.html',
  styleUrl: './action-cash-advance-approval.component.scss',
})
export class ActionCashAdvanceApprovalComponent {
  displayedColumns: string[] = [
    'user',
    'team',
    'sequence',
    'date',
    'status',
    'notes',
    'action',
  ];
  displayedSettlementColumn: string[] = [
    'refId',
    'description',
    'date',
    'location',
    'amount',
    'notes',
    'action',
  ];
  cashAdvance: any = null;
  cashAdvanceLogs: any[] = [];
  tag: any[] = [];
  allApproval: any[] = [];
  approvalList: any[] = [];
  latestApproval: any = null;
  currentApproval: any = null;
  settlementData: any[] = [];
  id: any;
  m: string;
  type: string;
  currentUser: any;
  currentStatus: string;
  sequenceFlow: boolean = true;
  totalAmount: number = 0;
  totalSisaKelebihan: number = 0;
  Math = Math;
  private avatarCache = new Map<number, string>();

  constructor(
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private cashAdvanceService: CashAdvanceService,
    private cashAdvanceLogService: CashAdvanceLogService,
    private cashAdvanceApprovalService: CashAdvanceApprovalService,
    private tagService: TagService,
    private fileService: FileService,
    private helpers: HelpersService,
    private authService: AuthService,
    private loadingService: LoadingService
  ) {
    this.id = this.activatedRoute.snapshot.queryParams['id'];
    this.m = this.activatedRoute.snapshot.queryParams['m'];
    this.type = this.activatedRoute.snapshot.queryParams['type'];
    this.currentUser = this.authService.getLoggedUser();
    this.getCashAdvance();
    this.getTag();
  }

  getCashAdvance() {
    this.loadingService.startLoading();
    this.cashAdvanceService.getApprovalById(this.id).then(
      (resp: any) => {
        this.loadingService.endLoading();
        this.cashAdvance = resp.cashAdvanceData;
        this.sequenceFlow = this.cashAdvance.expenseCategory.approval_sequence;
        this.settlementData = this.dedupeSettlementData(
          resp.settlementData.map((item: any) => this.normalizeSettlementItem(item)),
        );
        this.sortSettlementData();
        this.totalAmount = this.settlementData.reduce(
          (sum: number, item: any) => sum + (item.amount || 0),
          0
        );
        this.totalSisaKelebihan = this.cashAdvance.amount - this.totalAmount;
        this.currentStatus = this.cashAdvance.status;
        this.getCashAdvanceLog(this.cashAdvance.id);
        this.getApprovalList(this.cashAdvance.id);
      },
      (error) => {
        this.loadingService.endLoading();
        this.helpers.sbError(error.message);
      }
    );
  }

  getCashAdvanceLog(cashAdvanceId: any) {
    this.loadingService.startLoading();
    this.cashAdvanceLogService.getCashAdvanceLog(cashAdvanceId).then(
      (resp: any) => {
        this.loadingService.endLoading();
        this.cashAdvanceLogs = resp.map((item: any) => ({
          ...item,
          updated_at: this.toLogDate(item.updated_at),
          created_at: this.toLogDate(item.created_at),
        }));
        this.cashAdvanceLogs.forEach((item: any) => {
          this.getImageUrl(item.creator);
        });
      },
      (error) => {
        this.loadingService.endLoading();
        this.helpers.sbError(error.message);
      }
    );
  }

  getTag() {
    this.loadingService.startLoading();
    this.tagService.getAllData().then(
      (res) => {
        this.loadingService.endLoading();
        this.tag = res;
      },
      (error) => {
        this.loadingService.endLoading();
        this.helpers.sbError(error.message);
      }
    );
  }

  getApprovalList(cashAdvanceId: any) {
    this.loadingService.startLoading();
    this.cashAdvanceService.getApprovalList(cashAdvanceId).then(
      (resp: any) => {
        this.loadingService.endLoading();
        this.allApproval = resp;
        this.approvalList = resp.filter((item: any) => item.approve_at != null);
        this.currentApproval = resp.find((item: any) => item.isActive);
        if (this.approvalList.length) {
          this.latestApproval =
            this.approvalList[this.approvalList.length - 1].approval_note;
        }
      },
      (error) => {
        this.loadingService.endLoading();
        this.helpers.sbError(error.message);
      }
    );
  }

  private getImageUrl(user: any) {
    if (!user?.file?.id) {
      user.imageUrl = null;
      return;
    }

    if (user.id && this.avatarCache.has(user.id)) {
      user.imageUrl = this.avatarCache.get(user.id);
      return;
    }

    this.downloadAvatar(user, user.file.id);
  }

  private downloadAvatar(user: any, fileId: number) {
    this.fileService.download(fileId).subscribe(
      (res) => {
        const url = URL.createObjectURL(res);
        user.imageUrl = url;
        if (user.id) {
          this.avatarCache.set(user.id, url);
        }
      },
      () => {
        user.imageUrl = null;
      }
    );
  }

  download() {
    const files = this.getFileItems(this.cashAdvance);
    if (files.length) {
      if (files.length === 1) {
        this.openFile(files[0]);
        return;
      }

      files.forEach((item: any) => this.openFileInNewTab(item));
    } else {
      this.helpers.sbError('Tidak ada file yang bisa diunduh');
    }
  }

  openFile(file: any) {
    if (file) {
      const isMobile = window.innerWidth < 768;
      const canPreviewInline = this.helpers.canPreviewInline(file);

      if (isMobile || !canPreviewInline) {
        this.openFileInNewTab(file);
        return;
      }

      this.dialog
        .open(FilePreviewComponent, {
          width: '70vw',
          maxWidth: '70vw',
          maxHeight: '95vh',
          data: { file },
        })
        .afterClosed()
        .subscribe((item) => {
          if (item) {
          }
        });
    }
  }

  private openFileInNewTab(file: any) {
    this.loadingService.startLoading();
    this.fileService.download(file?.id).subscribe(
      (res) => {
        this.loadingService.endLoading();
        const url = URL.createObjectURL(res);
        const opened = window.open(url, '_blank', 'noopener,noreferrer');
        if (!opened) {
          const anchor = document.createElement('a');
          anchor.href = url;
          anchor.target = '_blank';
          anchor.rel = 'noopener noreferrer';
          anchor.click();
        }
        setTimeout(() => URL.revokeObjectURL(url), 60_000);
      },
      (error) => {
        this.loadingService.endLoading();
        this.helpers.sbError(error.message);
      }
    );
  }

  getFileItems(element: any): any[] {
    return this.helpers.normalizeFileItems(element);
  }

  approve(): void {
    this.dialog
      .open(ConfirmApprovalComponent, {
        width: '500px',
        maxHeight: '95vh',
        data: {
          expenseCategory: this.cashAdvance?.expenseCategory,
        },
      })
      .afterClosed()
      .subscribe((item) => {
        if (item) {
          const payload = item;
          payload['refId'] = this.cashAdvance.refId;
          this.loadingService.startLoading();
          this.cashAdvanceApprovalService
            .approve(payload)
            .then((resp: any) => {
              if (resp.success) {
                this.helpers.sbSuccess('Cash advance approved!');
              } else {
                this.helpers.sbError(resp.message);
              }
              this.loadingService.endLoading();
              this.getCashAdvanceLog(this.id);
              this.getApprovalList(this.id);
            })
            .catch((err: any) => {
              this.loadingService.endLoading();
              this.helpers.sbError(err.message);
            });
        }
      });
  }

  reject(): void {
    this.dialog
      .open(ConfirmApprovalComponent, {
        width: '500px',
        maxHeight: '95vh',
        data: {
          expenseCategory: this.cashAdvance?.expenseCategory,
        },
      })
      .afterClosed()
      .subscribe((item) => {
        if (item) {
          const payload = item;
          payload['refId'] = this.cashAdvance.refId;
          this.loadingService.startLoading();
          this.cashAdvanceApprovalService
            .reject(payload)
            .then((resp: any) => {
              if (resp.success || resp.susuccess) {
                this.helpers.sbSuccess('Cash advance rejected!');
              } else {
                this.helpers.sbError(resp.message);
              }
              this.loadingService.endLoading();
              this.getCashAdvanceLog(this.id);
              this.getApprovalList(this.id);
            })
            .catch((err: any) => {
              this.loadingService.endLoading();
              this.helpers.sbError(err.message);
            });
        }
      });
  }

  detail(data: any, sequence: any): void {
    data['sequence'] = sequence;
    this.dialog
      .open(DetailApprovalDialogComponent, {
        width: '700px',
        maxHeight: '95vh',
        data,
      })
      .afterClosed()
      .subscribe((item) => {
        if (item) {
        }
      });
  }

  checkCanApprove() {
    if (this.sequenceFlow) {
      if (!this.currentApproval) {
        return false;
      }
      return this.currentUser.id == this.currentApproval.user.id;
    } else {
      const approvalUserId = this.allApproval
        .filter((item: any) => item.approve_at == null)
        .map((item: any) => {
          return item.user.id;
        });
      return approvalUserId.includes(this.currentUser.id);
    }
  }

  checkSettlement(action: boolean) {
    const statusSettlement = [
      'Finance Approve',
      'Settlement Sent',
      'Settlement Sent To Finance',
      'Disbursed',
      'Settlement Rejected',
      'Rejected Finance',
    ];
    if (action) {
      return (
        (statusSettlement.includes(this.currentStatus) ||
          this.settlementData.length) &&
        this.cashAdvance.created_by == this.currentUser.id &&
        (this.currentStatus == 'Finance Approve' ||
          ((this.currentStatus == 'Settlement Rejected' ||
            this.currentStatus == 'Rejected Finance') &&
            this.type &&
            this.type == 'resubmit'))
      );
    } else {
      return (
        statusSettlement.includes(this.currentStatus) ||
        this.settlementData.length
      );
    }
  }

  addSettlement() {
    this.dialog
      .open(ActionSettlementComponent, {
        minWidth: '1000px',
        maxHeight: '95vh',
        data: {
          cashAdvance: this.cashAdvance,
          settlementData: null,
        },
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          result['refId'] = this.cashAdvance.refId;
          result['latitude'] = result['latitude'].toString();
          result['longitude'] = result['longitude'].toString();
          this.settlementData = this.dedupeSettlementData([
            ...this.settlementData,
            result,
          ]);
          this.sortSettlementData();
          this.totalAmount = this.settlementData.reduce(
            (sum: number, item: any) => sum + (item.amount || 0),
            0
          );
          this.totalSisaKelebihan = this.cashAdvance.amount - this.totalAmount;
        }
      });
  }

  detailSettlement(data: any) {
    this.dialog
      .open(ActionSettlementComponent, {
        minWidth: '1000px',
        maxHeight: '95vh',
        data: {
          cashAdvance: this.cashAdvance,
          settlementData: data,
        },
      })
      .afterClosed()
      .subscribe((result) => {
        console.log(result);
      });
  }

  updateSettlement(data: any, index: number) {
    this.dialog
      .open(ActionSettlementComponent, {
        minWidth: '1000px',
        maxHeight: '95vh',
        data: {
          cashAdvance: this.cashAdvance,
          settlementData: data,
          isEdit: true,
        },
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          result['refId'] = this.cashAdvance.refId;
          result['latitude'] = result['latitude'].toString();
          result['longitude'] = result['longitude'].toString();
          this.settlementData.splice(index, 1);
          this.settlementData = this.dedupeSettlementData([
            ...this.settlementData,
            result,
          ]);
          this.sortSettlementData();
        }
      });
  }

  removeSettlement(index: number) {
    this.settlementData.splice(index, 1);
    this.settlementData = [...this.settlementData];
    this.sortSettlementData();
  }

  private sortSettlementData() {
    this.settlementData = [...this.settlementData].sort((a: any, b: any) => {
      const aTime = new Date(
        a?.settlementDate ?? a?.created_at ?? a?.updated_at ?? 0
      ).getTime();
      const bTime = new Date(
        b?.settlementDate ?? b?.created_at ?? b?.updated_at ?? 0
      ).getTime();
      return bTime - aTime;
    });
  }

  private dedupeSettlementData(items: any[]): any[] {
    const map = new Map<string, any>();

    for (const item of items) {
      const key = `${item.amount}|${item.description ?? ''}|${item.notes ?? ''}|${item.location ?? ''}`;
      const existing = map.get(key);
      if (!existing || Number(item.id ?? 0) > Number(existing.id ?? 0)) {
        map.set(key, item);
      }
    }

    return Array.from(map.values());
  }

  private normalizeSettlementItem(item: any): any {
    const fileId = item.fileIds?.[0] ?? item.file?.id ?? item.fileId ?? null;
    return {
      ...item,
      desciption: item.desciption ?? item.description,
      tagId: item.tagId ?? item.tag?.id,
      fileId,
      fileIds: item.fileIds?.length
        ? item.fileIds
        : fileId
          ? [fileId]
          : [],
    };
  }

  private prepareSettlementPayload(items: any[]): any[] {
    return items.map((item) => {
      const normalized = this.normalizeSettlementItem(item);
      const fileIds = (normalized.fileIds?.length
        ? normalized.fileIds
        : normalized.file?.id
          ? [normalized.file.id]
          : normalized.fileId
            ? [normalized.fileId]
            : []
      )
        .map((id: any) => Number(id))
        .filter((id: number) => Number.isFinite(id) && id > 0);
      const fileId = fileIds.length ? fileIds[fileIds.length - 1] : null;
      const tagId = Number(normalized.tagId ?? normalized.tag?.id);
      const amount = Number(normalized.amount);

      return {
        amount,
        tagId,
        desciption: String(
          normalized.desciption ?? normalized.description ?? '',
        ),
        notes: String(normalized.notes ?? ''),
        location: String(normalized.location ?? ''),
        latitude:
          normalized.latitude != null && normalized.latitude !== ''
            ? String(normalized.latitude)
            : undefined,
        longitude:
          normalized.longitude != null && normalized.longitude !== ''
            ? String(normalized.longitude)
            : undefined,
        fileId: fileId ?? undefined,
        fileIds,
      };
    });
  }

  private formatApiError(error: any): string {
    if (!error) {
      return 'Terjadi kesalahan saat submit settlement';
    }

    const message = error.message ?? error.error;
    if (Array.isArray(message)) {
      return message.join(', ');
    }

    return typeof message === 'string'
      ? message
      : 'Terjadi kesalahan saat submit settlement';
  }

  private validateSettlementPayload(items: any[]): string | null {
    for (const [index, item] of items.entries()) {
      if (!Number.isFinite(item.amount) || item.amount <= 0) {
        return `Baris settlement ${index + 1}: nominal tidak valid`;
      }
      if (!Number.isFinite(item.tagId) || item.tagId <= 0) {
        return `Baris settlement ${index + 1}: tag wajib dipilih`;
      }
      if (!item.desciption?.trim()) {
        return `Baris settlement ${index + 1}: deskripsi wajib diisi`;
      }
      if (!item.fileId && (!item.fileIds || item.fileIds.length === 0)) {
        return `Baris settlement ${index + 1}: lampiran wajib diupload`;
      }
    }

    return null;
  }

  submitSettlement() {
    if (!this.settlementData.length) {
      this.helpers.sbError('Tambahkan data settlement sebelum submit');
      return;
    }

    const settlementData = this.prepareSettlementPayload(this.settlementData);
    const validationError = this.validateSettlementPayload(settlementData);
    if (validationError) {
      this.helpers.sbError(validationError);
      return;
    }

    const payload = {
      cashAdvanceId: this.cashAdvance.id.toString(),
      settlementData,
    };

    this.cashAdvanceService.submitSettlement(payload).then(
      () => {
        this.helpers.sbSuccess('Berhasil submit settlement');
        this.getCashAdvance();
      },
      (error) => {
        this.helpers.sbError(this.formatApiError(error));
      },
    );
  }

  resubmitSettlement() {
    if (!this.settlementData.length) {
      this.helpers.sbError('Tambahkan data settlement sebelum resubmit');
      return;
    }

    const settlementData = this.prepareSettlementPayload(this.settlementData);
    const validationError = this.validateSettlementPayload(settlementData);
    if (validationError) {
      this.helpers.sbError(validationError);
      return;
    }

    const payload = {
      cashAdvanceId: this.cashAdvance.id.toString(),
      settlementData,
    };

    this.cashAdvanceService.resubmitSettlement(payload).then(
      () => {
        this.helpers.sbSuccess('Berhasil resubmit settlement');
        this.getCashAdvance();
      },
      (error) => {
        this.helpers.sbError(this.formatApiError(error));
      },
    );
  }

  openProfile(userId: any) {
    this.dialog
      .open(ProfileDialogComponent, {
        maxWidth: '70vw',
        maxHeight: '95vh',
        data: userId,
      })
      .afterClosed()
      .subscribe((item) => {});
  }

  getStatusClass(status?: string | null): string {
    switch (status) {
      case 'Draft':
        return 'status-badge status-badge--draft';
      case 'Sent':
        return 'status-badge status-badge--sent';
      case 'Approved':
        return 'status-badge status-badge--approved';
      case 'Rejected':
      case 'Rejected Finance':
      case 'Settlement Rejected':
        return 'status-badge status-badge--rejected';
      case 'Sent To Finance':
      case 'Settlement Sent':
        return 'status-badge status-badge--finance-pending';
      case 'Finance Approve':
        return 'status-badge status-badge--finance-approved';
      case 'Reimbursed':
      case 'Disbursed':
        return 'status-badge status-badge--disbursed';
      case 'Settlement Verified':
        return 'status-badge status-badge--approved';
      case 'Settlement Sent To Finance':
        return 'status-badge status-badge--finance-pending';
      case 'Closed':
        return 'status-badge status-badge--draft';
      default:
        return 'status-badge status-badge--draft';
    }
  }

  getApprovalStatusClass(status: boolean | null | undefined): string {
    if (status === true) return 'status-badge status-badge--disbursed';
    if (status === false) return 'status-badge status-badge--rejected';
    return 'status-badge status-badge--draft';
  }

  getApprovalStatusLabel(status: boolean | null | undefined): string {
    if (status === true) return 'Approved';
    if (status === false) return 'Rejected';
    return '-';
  }

  isLogRejected(item: any): boolean {
    return !!item.description?.includes('Rejected');
  }

  getLogAccentClass(item: any): string {
    if (this.isLogRejected(item)) return 'timeline-accent--rejected';
    if (item.created_by == this.cashAdvance?.created_by) {
      return 'timeline-accent--creator';
    }
    if (item.creator?.role?.code == 'FIN') return 'timeline-accent--finance';
    return 'timeline-accent--approver';
  }

  getSettlementDate(element: any): Date | string | null {
    return element.settlementDate || element.created_at || element.updated_at || null;
  }

  getBalanceLabel(): string {
    return this.totalSisaKelebihan < 0 ? 'Kekurangan' : 'Sisa';
  }

  getBalanceClass(): string {
    if (this.totalSisaKelebihan < 0) return 'balance-value--negative';
    if (this.totalSisaKelebihan > 0) return 'balance-value--positive';
    return 'balance-value--neutral';
  }

  private toLogDate(value: any): Date | null {
    if (!value) return null;
    const parsed = moment(value);
    return parsed.isValid() ? parsed.toDate() : null;
  }

  getLogTimestamp(item: any): Date | null {
    return this.toLogDate(item.updated_at) ?? this.toLogDate(item.created_at);
  }

  isWaitingLog(item: any): boolean {
    return !!item.description?.includes('Waiting');
  }
}
